import { BRANDS_CATEGORY_ID } from "../consts/BRANDS_CATEGORY_ID";
import { CustomerTypes } from "../enums/CustomerType";
export var getCustomerType = function getCustomerType(categoryId) {
  if (!categoryId) {
    return CustomerTypes.UNKNOWN;
  }
  return categoryId === BRANDS_CATEGORY_ID ? CustomerTypes.BRAND : CustomerTypes.RETAILER;
};